module.exports = __webpack_public_path__ + "img/jia.61bbb501.svg";